const environmentMap = {
  development: "DEV",
  staging: "STG",
  production: "PROD"
};

export const getEnvironment = () => {
  const apiUrl = (process.env.VUE_APP_API_URL || "").toLowerCase();

  if (!apiUrl || apiUrl.includes("development")) {
    return "development";
  }

  if (apiUrl.includes("staging")) {
    return "staging";
  }

  return "production";
};

export const getEnvironmentTitle = () => {
  return environmentMap[getEnvironment()];
};
